import {useForm} from "react-hook-form";
import React, {useCallback, useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import LinearProgress from '@mui/material/LinearProgress';
import {addAssetType} from "../../../Services/AssetManagement/AssetTypeService";
import AssetTypeForm from "../../../Components/Forms/Pages/AssetManagement/AssetType/AssetTypeForm";
import { getVendors } from '../../../Services/AssetManagement/VendorService';
import { getAssetCategories } from '../../../Services/AssetManagement/AssetCategoryService';
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'name': {required: true}
}

const AddAssetType = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        setDrawerTitle(strings.pages.assetManagement.assetType.addAssetType.pageTitle);
    });

    useEffect(() => {
        fetchAssetCategories();
        fetchVendors();
    }, [])

    const fetchAssetCategories = (term = "") =>{
        getAssetCategories({term}).then((response) => {
            if (!response || !response.ok) {
              return;
            }
            setCategories(response.data.result);
          });
    }

    const fetchVendors = (term = "") =>{
        getVendors({term}).then((response) => {
            if (!response || !response.ok) {
              return;
            }
            setVendors(response.data.result);
          });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        addAssetType(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <AssetTypeForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                vendors={vendors}
                categories={categories}
                errors={errors} data={data} form={form} control={control}
                onAssetCategoryChangeFilter={fetchAssetCategories}
                onVendorChangeFilter={fetchVendors}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default AddAssetType;